export default "__VITE_ASSET__cf45d1c9__$_?component__"